import {Injectable} from '@angular/core';
import {MetaMenu} from '../meta.menu';
import { HttpClient } from '@angular/common/http';
import {map, switchMap} from 'rxjs/operators';
import {Observable} from 'rxjs';

export interface Content {
  contentId: number;
  name: string;
  html: string;
  linkLabel: string;
  visibility: string;
  lastUpdated: string;
  editable: boolean;
}

@Injectable()
export class MetaMenuService {

  constructor(protected readonly http: HttpClient) { }

  find(): Observable<MetaMenu> {
    return this.http.get<Content>('/rest/content/MENU').pipe(
      map((content: Content) => {
        if (content && content.html) {
          return JSON.parse(content.html) as MetaMenu;
        }
        return { menuList: [] }; // Return empty menu if content is invalid
      })
    );
  }

  update(metaMenu: MetaMenu): Observable<void> {
    return this.http.get<Content>('/rest/content/MENU').pipe(
      switchMap((content: Content) => {
        const newContent = { ...content, html: JSON.stringify(metaMenu, null, 2) };
        return this.http.post<void>('/rest/content', newContent);
      })
    );
  }
}
